import addressesServiceGen from "./generated/addressesServiceGen";

class addressesService extends addressesServiceGen {
}

export default addressesService;